import React from 'react';
import type { TextElement as TextElementType } from '@frontend/Models/TopBar/TopBarModels';

/**
 * TextElement - Simple text display component for TopBar
 */
const TextElement: React.FC<TextElementType> = ({ text, style }) => {
  return (
    <span className="topBar-text" style={style}>
      {text}
    </span>
  );
};

export default TextElement;
